import ClickLogger from '@/components/common/ClickLogger';
import Link from 'next/link';
import { CATEGORY_ITEM_STYLES } from '../lib/constants';
import { CategoryData } from '../types/category';

interface CategoryItemProps {
  category: CategoryData;
  categoryPath: string;
}

const CategoryItem = ({ category, categoryPath }: CategoryItemProps) => {
  return (
    <ClickLogger params={{ eventName: 'category_item_click', payload: { categoryId: category.id ?? '' } }}>
      <Link href={categoryPath}>
        <a className='flex min-h-[88px] cursor-pointer flex-col items-center justify-center gap-[12px] rounded-[8px] p-[8px] sm:min-h-[108px]'>
          <div className={CATEGORY_ITEM_STYLES.ICON_CONTAINER}>
            <img src={category.iconUrl ?? ''} alt={category.name ?? ''} className={CATEGORY_ITEM_STYLES.ICON} />
          </div>
          <span className={CATEGORY_ITEM_STYLES.NAME}>{category.name ?? ''}</span>
        </a>
      </Link>
    </ClickLogger>
  );
};

export default CategoryItem;
